









































// import HeaderSearch from './HeaderSearch.vue'
import HeaderAvatar from "./HeaderlAvatar.vue";
import IMenu from "@/components/menu/menu.ts";
import ViewBase from "@/utils/ViewBase";
import { Component, Prop } from "vue-property-decorator";
import tryParseJson from "@/fn/tryParseJson";
import { setUser, appId } from "@/store";

@Component({
  components: {
    // HeaderSearch,
    HeaderAvatar,
    IMenu
  }
})
export default class Main extends ViewBase {
  @Prop() menuData: any;
  @Prop() collapsed: any;

  get isMobile() {
    return this.$store.state.setting.isMobile;
  }

  get layout() {
    return this.$store.state.setting.layout;
  }

  get theme() {
    return this.layout === "side" ? "light" : this.$store.state.setting.theme;
  }

  get systemName() {
    return this.$store.state.setting.systemName;
  }

  toggleCollapse() {
    this.$emit("toggleCollapse");
  }

  changelan(value: any) {
    this.$i18n.locale = value.target.value;
    this.$store.commit("setting/changelan", value.target.value);
    const userid: any = tryParseJson(localStorage.getItem("user"));
    setUser({
      id: userid.id,
      channel_id: userid.channel_id,
      name: userid.name,
      token: userid.token,
      language: value.target.value
    });
  }

  onSelect(obj: any) {
    this.$emit("menuSelect", obj);
  }
}
